import { IconCompass } from "@tabler/icons-react"
import { type FC, useState } from "react"

import Button from "~/components/Button"
import { DefaultModal, ModalButtons, ModalTitle } from "~/components/Modal"

import { AnalyticsCard, AnalyticsCardHeader } from "./shared"

const maxSources = 8

const Sources: FC<{ sources: { label: string; visitsShare: number }[] }> = ({ sources }) => {
	const [isShowAllModalOpen, setShowAllModalOpen] = useState(false)

	return (
		<>
			<DefaultModal onClose={() => setShowAllModalOpen(false)} isOpen={isShowAllModalOpen}>
				<ModalTitle>Sources</ModalTitle>
				<ol className="mx-8 mb-5 max-h-125 list-none overflow-y-auto">
					{sources.map(source => (
						<Source key={source.label} source={source} />
					))}
				</ol>
				<ModalButtons>
					<Button variant="primary" onClick={() => setShowAllModalOpen(false)}>
						Close
					</Button>
				</ModalButtons>
			</DefaultModal>
			<AnalyticsCard gridArea="sources" className="flex flex-col gap-6">
				<AnalyticsCardHeader Icon={IconCompass} title="Sources" />
				{sources.length > 0 ? (
					<ol className="list-none">
						{sources.slice(0, maxSources).map(source => (
							<Source key={source.label} source={source} />
						))}
					</ol>
				) : (
					<p className="text-sm text-gray-500">No recorded sources</p>
				)}
				{sources.length > maxSources && (
					<Button variant="secondary" onClick={() => setShowAllModalOpen(true)} className="self-start">
						Show all
					</Button>
				)}
			</AnalyticsCard>
		</>
	)
}

type SourceProps = { source: { label: string; visitsShare: number } }
const Source: FC<SourceProps> = ({ source }) => (
	<li className="flex min-w-0 items-center justify-between gap-3 border-b border-gray-100 py-3 last:border-b-0">
		<p className="min-w-0 flex-1 truncate text-sm" title={source.label}>
			{source.label}
		</p>
		<p className="shrink-0 text-sm font-semibold whitespace-nowrap">{(source.visitsShare * 100).toFixed(2)}%</p>
	</li>
)

export default Sources
